export class ScrollService {
  #ATTRIBUTE_LOGO_SCROLLED = 'data-logo-scrolled';
  #SCROLL_THRESHOLD = 80;

  constructor() {
    window.addEventListener('scroll', (): void => {
      this.#handleScroll();
    });
  }

  #handleScroll(): void {
    const element: HTMLElement = document.documentElement;
    const scrollPosition: number = element.scrollTop;

    if (scrollPosition > this.#SCROLL_THRESHOLD) {
      element.setAttribute(this.#ATTRIBUTE_LOGO_SCROLLED, '');
      return;
    }

    element.removeAttribute(this.#ATTRIBUTE_LOGO_SCROLLED);
  }
}
